import { useState } from "react";
import classNames from "classnames";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { useTranslation } from "react-i18next";
import { Page, Group, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useModal, useFetch, useForm, useToast, useResource } from "@/comn/hooks";
import { useLogin, APIS, SF_CSTM_OFCR_INFO_FORM } from "@/comn/features/authentication/useLogin";

const RenewalAccount = () => {
    const imgs = { imgLock: `${process.env.PUBLIC_URL}/imgs/img-lock.png` };
    const { t } = useTranslation();
    const toast = useToast();
    const modal = useModal();
    const { showToast } = useToast();
    const { logout } = useLogin();

    const key = process.env.REACT_APP_SYSTEM_GROUP == "tanoga" ? "tanesw" : process.env.REACT_APP_SYSTEM_GROUP || "";
    const base =
        process.env.REACT_APP_SYSTEM_GROUP == "tancis"
            ? process.env.REACT_APP_API_PTLI
            : process.env.REACT_APP_API_PTLE;

    const [reactivateAccountForm, setReactivateAccountForm] = useState({
        usrId: "",
        cstmOfcrNo: "",
        cstmSctnOrgzCd: "",
        cstmOfceCd: "",
        cstmUnitOrgzCd: "",
    });

    const { usrId, cstmOfcrNo, cstmSctnOrgzCd, cstmOfceCd, cstmUnitOrgzCd } = reactivateAccountForm;

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [{ area: "cstmCd" }, { area: "orgzSub" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        cstmOfcrInfo: useForm({
            defaultSchema: SF_CSTM_OFCR_INFO_FORM,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Section search by customs !== 섹션별 세관 조회 ==!
        getCstmList: useFetch({
            api: () => APIS.getOrgzList(form.cstmOfcrInfo.getValues()),
            enabled: false,
            onSuccess: (data) => {
                //console.log(data);
                if (data.orgzList.content.length > 0) {
                    form.cstmOfcrInfo.setSchema("cstmOfceCd", {
                        options: data.orgzList.content.map((item: any, index: number) => ({
                            label: item.cstmOrgzNm,
                            value: item.cstmOrgzCd,
                        })),
                    });
                }
                handler.getUnitList(form.cstmOfcrInfo.getValue("loadYn"));
            },
            onError: () => {},
        }),

        // Unit search by section !== 섹션별 유닛 조회 ==!
        getUnitList: useFetch({
            api: () => APIS.getOrgzList(form.cstmOfcrInfo.getValues()),
            enabled: false,
            onSuccess: (data) => {
                if (data.orgzList.content.length > 0) {
                    form.cstmOfcrInfo.setSchema("cstmUnitOrgzCd", {
                        options: data.orgzList.content.map((item: any) => ({
                            label: item.cstmOrgzNm,
                            value: item.cstmOrgzCd,
                        })),
                    });
                }
                // handler.getCstmRoleList(form.cstmOfcrInfo.getValue("loadYn"));
            },
            onError: () => {},
        }),

        // Section search by customs role !== 조직 역할 목록 조회 ==!
        getCstmRoleList: useFetch({
            api: (objParam) => APIS.getCstmRoleList(objParam),
            enabled: false,
            onSuccess: (data) => {
                if (data?.cstmRoleList?.content.length > 0) {
                    form.cstmOfcrInfo.setSchema("roleId", {
                        options: data.cstmRoleList.content.map((item: any) => ({
                            label: item.roleNm,
                            value: item.roleId,
                        })),
                    });
                } else {
                    form.cstmOfcrInfo.setSchema("roleId", { options: [] });
                    form.cstmOfcrInfo.setValue("roleId", "");
                }
            },
            onError: () => {},
        }),
    };

    const handler = {
        handleSubmit: async () => {
            if (process.env.REACT_APP_SYSTEM_GROUP == "tancis") {
                if (comnUtils.isEmptyString(cstmSctnOrgzCd)) {
                    toast.showToast({ type: "error", content: t("msg.com.00035", { 0: t("L_CSTM_SCTN") }) }); // Please enter {0}. !== {0} 을(를) 입력하여 주세요. ==!
                    return;
                } else if (comnUtils.isEmptyString(cstmOfceCd)) {
                    toast.showToast({ type: "error", content: t("msg.com.00035", { 0: t("L_CSTM_OFCE") }) }); // Please enter {0}. !== {0} 을(를) 입력하여 주세요. ==!
                    return;
                }
            }

            const caseMap: any = {
                tancis: {
                    url: "/api/v1/ptli/mypage/myinfo/renew/usr",
                    payload: { usrDmnId: usrId, cstmOfcrNo, cstmSctnOrgzCd, cstmOfceCd, cstmUnitOrgzCd },
                },
                tanesw: { url: "/api/v1/ptle/extptl/mypage/myinfochg/renew/usr", payload: { tin: usrId } },
            };

            try {
                await api.post(base + caseMap[key].url, caseMap[key].payload);

                modal.openModal({
                    content:
                        "User information updated successfully.\nRedirecting to the main page.\r\n\r\nIf there are any issues,\nplease contact [+255677050534/0677050523]",
                    onClose: () => logout(),
                });
            } catch (e: any) {
                console.log(e);
                toast.showToast({ content: e.response?.data?.errorMessage || "error", type: "error" });
            }
        },

        // Section search by customs !== 섹션별 세관 조회 ==!
        getCstmList: (loadYn: any) => {
            if (loadYn !== "Y") {
                form.cstmOfcrInfo.setSchema("cstmOfceCd", { options: [] });
                form.cstmOfcrInfo.setSchema("cstmUnitOrgzCd", { options: [] });
                //form.cstmOfcrInfo.setSchema("roleId", { options: [] });

                form.cstmOfcrInfo.setValue("cstmOfceCd", "");
                form.cstmOfcrInfo.setValue("cstmUnitOrgzCd", "");
                //form.cstmOfcrInfo.setValue("roleId", "");
            }

            form.cstmOfcrInfo.setValue("cstmOrgzTpCd", "C");
            form.cstmOfcrInfo.setValue("loadYn", "Y");

            fetch.getCstmList.fetch();
        },

        // Unit search by section !== 세관별 유닛 조회 ==!
        getUnitList: (loadYn: any) => {
            if (loadYn !== "Y") {
                form.cstmOfcrInfo.setSchema("cstmUnitOrgzCd", { options: [] });
                //form.cstmOfcrInfo.setSchema("roleId", { options: [] });
                form.cstmOfcrInfo.setValue("cstmUnitOrgzCd", "");
                //form.cstmOfcrInfo.setValue("roleId", "");
            }

            form.cstmOfcrInfo.setValue("cstmOrgzTpCd", "U");
            form.cstmOfcrInfo.setValue("loadYn", "Y");

            fetch.getUnitList.fetch();
        },

        // Section search by customs role !== 세관 역할 조회 ==!
        getCstmRoleList: (loadYn: any) => {
            if (loadYn !== "Y") {
                form.cstmOfcrInfo.setSchema("roleId", { options: [] });
                form.cstmOfcrInfo.setValue("roleId", "");
            }

            const cstmSctnOrgzCd = form.cstmOfcrInfo.getValue("cstmSctnOrgzCd");

            // Initialize role combo if there is no section code !== 섹션 코드 없는 경우 역할 콤보 초기화 ==!
            if (comnUtils.isEmpty(cstmSctnOrgzCd)) {
                form.cstmOfcrInfo.setSchema("roleId", { options: [] });
                form.cstmOfcrInfo.setValue("roleId", "");
                return;
            }

            const cstmOfceCd = form.cstmOfcrInfo.getValue("cstmOfceCd");
            const cstmUnitOrgzCd = form.cstmOfcrInfo.getValue("cstmUnitOrgzCd");
            const cstmOrgzTpCd = comnUtils.isEmpty(cstmOfceCd) ? "S" : !comnUtils.isEmpty(cstmUnitOrgzCd) ? "U" : "C";
            const objParam = { cstmSctnOrgzCd, cstmOfceCd, cstmUnitOrgzCd, cstmOrgzTpCd };
            fetch.getCstmRoleList.fetch(objParam);
        },
    };

    return (
        <div className="w-full h-auto lg:h-[calc(100vh-250px)] flex items-center relative">
            <div className="find-content-wrap w-full h-auto top-0 left-0 flex items-center justify-center my-[90px] ">
                <div className={classNames("find-content-min w-full md:w-[520px] lg:w-[520px] h-auto relative")}>
                    <img
                        src={imgs["imgLock"]}
                        width={"700px"}
                        height={"auto"}
                        className="grayscale opacity-10 absolute top-[100px] -left-[300px] -z-[1] hidden md:block lg:block"
                        alt=""
                    />
                    <div className="find-header bg-primary p-[30px] relative rounded-t-[30px]">
                        <h2 className="text-2xl text-white">Renew account details</h2>
                        <span className="block w-[214px] lg:w-[214px] absolute -top-[70px] -right-[10px] lg:-right-[70px]">
                            <img src={imgs["imgLock"]} width={"100%"} height={"auto"} className="" alt="" />
                        </span>
                    </div>
                    <form
                        className="find-body rounded-b-[30px] p-[40px] pt-[70px] bg-card flex flex-col gap-[70px] shadow-lg"
                        onSubmit={(event: any) => {
                            event.preventDefault();

                            modal.openModal({
                                content:
                                    "Please confirm that the user information \nyou want to update is correct.\r\n\r\nIf there are any issues,\nplease contact [+255677050534/0677050523]",
                                onConfirm: async () => await handler.handleSubmit(),
                            });
                        }}
                    >
                        <div className="find-body-min flex flex-col gap-[14px]">
                            {process.env.REACT_APP_SYSTEM_GROUP == "tancis" ? (
                                <>
                                    <p className="flex gap-[5px]">
                                        <label htmlFor="username" className="block w-[125px] text-sm pt-[8px]">
                                            Domain ID
                                        </label>
                                        <span className="flex flex-col gap-[4px] w-full">
                                            <input
                                                id="usrId"
                                                type="text"
                                                className="text-sm input bg-transparent h-[36px] w-full"
                                                value={usrId}
                                                onChange={(event) =>
                                                    setReactivateAccountForm((prev) => ({
                                                        ...prev,
                                                        usrId: event.target.value,
                                                    }))
                                                }
                                            />
                                        </span>
                                    </p>

                                    <p className="flex gap-[5px]">
                                        <label htmlFor="usernumber" className="block w-[125px] text-sm pt-[8px]">
                                            Employee No
                                        </label>
                                        <span className="flex flex-col gap-[4px] w-full">
                                            <input
                                                id="cstmOfcrNo"
                                                type="text"
                                                className="text-sm input bg-transparent h-[36px] w-full"
                                                value={cstmOfcrNo}
                                                onChange={(event) => {
                                                    setReactivateAccountForm((prev) => ({
                                                        ...prev,
                                                        cstmOfcrNo: event.target.value,
                                                    }));
                                                }}
                                                required={true}
                                            />
                                        </span>
                                    </p>
                                    <div className="flex gap-[5px]">
                                        <label htmlFor="usernumber" className="block w-[120px] text-sm pt-[8px]">
                                            Customs Section
                                        </label>
                                        <span className="flex flex-col gap-[4px] w-full">
                                            <Group.Control
                                                id="cstmSctnOrgzCd"
                                                {...form.cstmOfcrInfo.schema.cstmSctnOrgzCd}
                                                popupParams={{ cstmOrgzTpCd: "S" }}
                                                onChange={(event) => {
                                                    handler.getCstmList("N");
                                                    setReactivateAccountForm((prev) => ({
                                                        ...prev,
                                                        cstmSctnOrgzCd: event,
                                                    }));
                                                }}
                                                required={true}
                                            />
                                        </span>
                                    </div>
                                    <div className="flex gap-[5px]">
                                        <label htmlFor="usernumber" className="block w-[120px] text-sm pt-[8px]">
                                            Customs Office
                                        </label>
                                        <span className="flex flex-col gap-[4px] w-full">
                                            <Group.Control
                                                id="cstmOfceCd"
                                                {...form.cstmOfcrInfo.schema.cstmOfceCd}
                                                onChange={(event) => {
                                                    handler.getUnitList("N");
                                                    setReactivateAccountForm((prev) => ({
                                                        ...prev,
                                                        cstmOfceCd: event,
                                                    }));
                                                }}
                                                required={true}
                                            />
                                        </span>
                                    </div>
                                    <div className="flex gap-[5px]">
                                        <label htmlFor="usernumber" className="block w-[120px] text-sm pt-[8px]">
                                            Customs Unit
                                        </label>
                                        <span className="flex flex-col gap-[4px] w-full">
                                            <Group.Control
                                                id="cstmUnitOrgzCd"
                                                {...form.cstmOfcrInfo.schema.cstmUnitOrgzCd}
                                                onChange={(event) => {
                                                    setReactivateAccountForm((prev) => ({
                                                        ...prev,
                                                        cstmUnitOrgzCd: event,
                                                    }));
                                                }}
                                            />
                                        </span>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <p className="flex gap-[5px]">
                                        <label htmlFor="username" className="block w-[100px] text-sm pt-[8px]">
                                            Individual TIN
                                        </label>
                                        <span className="flex flex-col gap-[4px] w-full">
                                            <input
                                                id="usrId"
                                                type="text"
                                                className="text-sm input bg-transparent h-[36px] w-full"
                                                value={usrId}
                                                onChange={(event) =>
                                                    setReactivateAccountForm((prev) => ({
                                                        ...prev,
                                                        usrId: event.target.value,
                                                    }))
                                                }
                                            />
                                        </span>
                                    </p>
                                </>
                            )}
                        </div>
                        <div className="flex gap-[10px]">
                            <button
                                type="submit"
                                className={classNames(
                                    "w-full rounded-[32px] h-[60px] text-base bg-primary-fill-5 border border-primary text-primary dark:text-white dark:border-white dark:hover:border-primary",
                                    "hover:bg-primary hover:text-white hover:border-primary",
                                )}
                            >
                                Renew account
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default RenewalAccount;
